/**
 * BackBar - Globale terugnavigatie
 * Toont een subtiele "← Terug" link op alle pagina's behalve het dashboard.
 * Gebruikt browser history (navigate(-1)) om naar de vorige pagina te gaan.
 * Biedt ook "Dashboard" als fallback wanneer er geen geschiedenis is.
 */

import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft, Home } from 'lucide-react'

function BackBar() {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const isDashboard = location.pathname === '/dashboard' || location.pathname === '/'

  if (isDashboard) {
    return null
  }

  return (
    <div className="flex items-center gap-4 mb-6 pb-4 border-b border-gray-200 dark:border-gray-700">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors font-medium"
        title={t('common.back', 'Terug')}
      >
        <ArrowLeft className="w-4 h-4" />
        <span>{t('common.back', 'Terug')}</span>
      </button>
      <span className="text-gray-300 dark:text-gray-600">|</span>
      <button
        onClick={() => navigate('/dashboard')}
        className="flex items-center gap-2 text-gray-500 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors text-sm"
        title={t('navigation.dashboard', 'Dashboard')}
      >
        <Home className="w-4 h-4" />
        <span>{t('navigation.dashboard', 'Dashboard')}</span>
      </button>
    </div>
  )
}

export default BackBar
